import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as tpaDailyReportAction from "../../../store/tpadaily-report/action";

import {
    Col,
    Container,
    Input,
    InputGroup,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";
import {
    DELETE_STOCK_RP_TPA_DAILY_REPORT,
    GET_STOCK_RP_TPA_DAILY_REPORT,
    SAVE_LIST_STOCK_RP_TPA_DAILY_REPORT,
    SAVE_STOCK_RP_TPA_DAILY_REPORT,
} from "../../../helpers/url_api_constant";
import { Link, useHistory, useParams } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";

import Flatpickr from "react-flatpickr";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import debounce from "lodash.debounce";
import moment from "moment";
import { useDispatch } from "react-redux";

function TableTwo(props) {
    let history = useHistory();
    let { pid } = useParams();

    const dispatch = useDispatch();
    const permission = getPermission();
    const searchObj = { TPADAILY_PID: pid, };
    const model = {
        TPADAILY_PID: props.tpaDailyReportPid,
        SUMENERGYENTRY: 0,
        SUMENERGYEXIT: 0,
        SUMENERGYBALANCE: 0,
        SUMENERGYCHANGE: 0,
        SUMENERGYSHRINKAGE: 0,
        SUMENERGYSUMDAY: 0,
        SUMENERGYACCUM: 0,
        SUMENERGYRESERVE: 0,
    };
    const [tableTwoModel, setTableTwoModel] = useState(model);

    //render Index//
    const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
    //render Index//

    const rowStyleFontWhite = (row, rowIndex) => {
        const style = {};
        // style.fontWeight = 'bold';
        style.color = 'white';

        return style;
    };

    //onInit//
    useEffect(function () {
        fetchData();
        // resetSearch();
        // resetModel();
        // setModelDeviceList(listData);
    }, [props.tpaDailyReportPid]);
    //onInit//

    const setDispatchAction = useMemo(
        () =>
            debounce((value) => {
                // console.log(value);
                dispatch(
                    tpaDailyReportAction.setTableTwoStockTPAToState({
                        ...value,
                        SUMENERGYENTRY: value.SUMENERGYENTRY,
                        SUMENERGYEXIT: value.SUMENERGYEXIT,
                        SUMENERGYBALANCE: value.SUMENERGYBALANCE,
                        SUMENERGYCHANGE: value.SUMENERGYCHANGE,
                        SUMENERGYSHRINKAGE: value.SUMENERGYSHRINKAGE,
                        SUMENERGYSUMDAY: value.SUMENERGYSUMDAY,
                        SUMENERGYACCUM: value.SUMENERGYACCUM,
                        SUMENERGYRESERVE: value.SUMENERGYRESERVE,

                    })
                );
            }, 300),
        []
    );
    useEffect(() => {
        setDispatchAction(tableTwoModel);
    }, [tableTwoModel]);


    const fetchData = async () => {
        // dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_STOCK_RP_TPA_DAILY_REPORT, { TPADAILY_PID: props.tpaDailyReportPid });
            let data = res.data.rpTPAStockList[0];
            // console.log(data);
            setTableTwoModel({
                ...data, SUMENERGYENTRY: data.SUMENERGYENTRY.toFixed(4),
                SUMENERGYEXIT: data.SUMENERGYEXIT.toFixed(4),
                SUMENERGYBALANCE: data.SUMENERGYBALANCE.toFixed(4),
                SUMENERGYCHANGE: data.SUMENERGYCHANGE.toFixed(4),
                SUMENERGYSHRINKAGE: data.SUMENERGYSHRINKAGE.toFixed(4),
                SUMENERGYSUMDAY: data.SUMENERGYSUMDAY.toFixed(4),
                SUMENERGYACCUM: data.SUMENERGYACCUM.toFixed(4),
                SUMENERGYRESERVE: data.SUMENERGYRESERVE.toFixed(4),
            });
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        // dispatch(loadingAction.hideLoading());
    };

    return (
        // <div>
        <Row>
            <Col sm="1"></Col>
            <Col sm="10">
                <div className="table-responsive">
                    {/* hover-table-highlight */}

                    <Table className="table table-bordered mb-0">
                        <thead>
                            <tr>
                                <th colSpan={2} style={{ backgroundColor: "#556ee64a", color: "#FFFFFF", textAlign: "center", width: "100%" }}>ข้อมูลสรุปการบริหารปริมาณก๊าซบบนบก (หน่วย : MMBTU)</th>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: "#556ee678", color: "#FFFFFF", textAlign: "center", width: "25%" }}>รายการ</th>
                                <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "25%" }}>Total Onshore</th>
                            </tr>
                        </thead>
                        <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>

                            <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณก๊าซนำเข้าที่ Entry Point</label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                style={{ textAlign: "right", }}
                                                type="number"
                                                readOnly={props.readOnly}
                                                className="form-control basicborder"
                                                onChange={(e) => setTableTwoModel(
                                                    {
                                                        ...tableTwoModel,
                                                        SUMENERGYENTRY: e.target.value
                                                    })
                                                }
                                                value={tableTwoModel.SUMENERGYENTRY}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณก๊าซส่งออกที่ Exit Point</label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                style={{ textAlign: "right", }}
                                                type="number"
                                                readOnly={props.readOnly}
                                                className="form-control basicborder"
                                                onChange={(e) => setTableTwoModel(
                                                    {
                                                        ...tableTwoModel,
                                                        SUMENERGYEXIT: e.target.value
                                                    })
                                                }
                                                value={tableTwoModel.SUMENERGYEXIT}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณก๊าซปรับสมดุล</label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                style={{ textAlign: "right", }}
                                                type="number"
                                                readOnly={props.readOnly}
                                                className="form-control basicborder"
                                                onChange={(e) => setTableTwoModel(
                                                    {
                                                        ...tableTwoModel,
                                                        SUMENERGYBALANCE: e.target.value
                                                    })
                                                }
                                                value={tableTwoModel.SUMENERGYBALANCE}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณก๊าซค้างในท่อและก๊าซสำรองที่เปลี่ยนแปลง</label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                style={{ textAlign: "right", }}
                                                type="number"
                                                readOnly={props.readOnly}
                                                className="form-control basicborder"
                                                onChange={(e) => setTableTwoModel(
                                                    {
                                                        ...tableTwoModel,
                                                        SUMENERGYCHANGE: e.target.value
                                                    })
                                                }
                                                value={tableTwoModel.SUMENERGYCHANGE}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณ Shrinkage Gas และตัวแปรอื่นๆ </label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                style={{ textAlign: "right", }}
                                                type="number"
                                                readOnly={props.readOnly}
                                                className="form-control basicborder"
                                                onChange={(e) => setTableTwoModel(
                                                    {
                                                        ...tableTwoModel,
                                                        SUMENERGYSHRINKAGE: e.target.value
                                                    })
                                                }
                                                value={tableTwoModel.SUMENERGYSHRINKAGE}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณก๊าซความไม่สมดุลรายวัน </label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                style={{ textAlign: "right", }}
                                                type="number"
                                                readOnly={props.readOnly}
                                                className="form-control basicborder"
                                                onChange={(e) => setTableTwoModel(
                                                    {
                                                        ...tableTwoModel,
                                                        SUMENERGYSUMDAY: e.target.value
                                                    })
                                                }
                                                value={tableTwoModel.SUMENERGYSUMDAY}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณก๊าซความไม่สมดุลสะสม </label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                style={{ textAlign: "right", }}
                                                type="number"
                                                readOnly={props.readOnly}
                                                className="form-control basicborder"
                                                onChange={(e) => setTableTwoModel(
                                                    {
                                                        ...tableTwoModel,
                                                        SUMENERGYACCUM: e.target.value
                                                    })
                                                }
                                                value={tableTwoModel.SUMENERGYACCUM}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณก๊าซค้างในท่อและก๊าซสำรองสะสม </label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                style={{ textAlign: "right", }}
                                                type="number"
                                                readOnly={props.readOnly}
                                                className="form-control basicborder"
                                                onChange={(e) => setTableTwoModel(
                                                    {
                                                        ...tableTwoModel,
                                                        SUMENERGYRESERVE: e.target.value
                                                    })
                                                }
                                                value={tableTwoModel.SUMENERGYRESERVE}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </Col>
            <Col sm="1"></Col>
        </Row>
        // </div>
    );
}

TableTwo.propTypes = {
    t: PropTypes.any,
    tpaDailyReportPid: PropTypes.any,
    readOnly: PropTypes.any,
};


export default TableTwo;


